import { Theme } from '@mui/material';
import { BorderColor } from '../../../../common/model/BorderColor';
import { BorderMapper } from '../../../../common/mapper/BorderMapper';

const toBoxShadow = (theme: Theme, noShadow?: boolean, outlined?: boolean): string =>
  outlined || noShadow ? 'none' : theme.shadows[1];

const toOutline = (theme: Theme, outlined?: boolean, border?: BorderColor): string => {
  if (outlined) {
    return `1px solid ${theme.palette.grey[400]}`;
  } else if (border) {
    return `1px solid ${BorderMapper.colors(theme, border)}`;
  } else {
    return 'unset';
  }
};

const toBorderLeftColor = (theme: Theme, highlightColor?: BorderColor): string => {
  if (highlightColor) {
    return BorderMapper.colors(theme, highlightColor);
  } else {
    return theme.palette.transparent.default;
  }
};

export const ListRowMapper = {
  colorsMap: BorderMapper.colors,
  toBoxShadow,
  toBorderLeftColor,
  toOutline,
};
